import React from 'react'
import '../css/sliding-text.css'

const SlidingText = () => {
  return (
    <div className='sliding-text'>
      <p>Note: "We are proud to announce that our resort is the only one in Dhanaulti equipped with an EV charger!"</p>
    </div>
  )
}

export default SlidingText
